module.exports = __webpack_public_path__ + "media/images/black-caret-e18aee9b7311c704447de8f265ae1ec4.svg";